import React from 'react';
import { colors } from '../../styles/theme';

interface NumberedStepProps {
  number: number;
  children: React.ReactNode;
  color?: string;
}

const NumberedStep: React.FC<NumberedStepProps> = ({ 
  number, 
  children,
  color = colors.primary
}) => {
  return (
    <div className="flex items-start space-x-3">
      <div 
        className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-sm font-medium mt-0.5"
        style={{ 
          backgroundColor: `${color}15`,
          color: color
        }}
      >
        {number}
      </div>
      <div className="flex-1 pt-1">
        {children}
      </div>
    </div>
  );
};

export default NumberedStep;